import api from "../api";

export const updateReport = async (reportId, report) => {
  return api.patch(`/reports/${reportId}`, report);
}
